import { useParams } from "react-router-dom";
import { blogPosts } from "../../data/blogPosts";
import "./BlogArticle.css";

function BlogArticle() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) return <h2>Article not found</h2>;

  return (
    <div className="blog-article-container">
      <img src={post.image} alt={post.title} className="featured-image" />
      <h1 className="article-title">{post.title}</h1>
      <div className="article-content">
        <p>{post.content}</p>
      </div>
    </div>
  );
}

export default BlogArticle;
